import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TABS } from 'src/app/dummy/tab';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { Location } from '@angular/common';
import { SKILL_OBJECT, STATUS_OBJECT, DISPLAY_STATUS_OBJECT } from 'src/app/dummy/status';
import { IActivity } from 'src/app/interfaces/resource';
import { ConvertService, removeObjArray, pushObjArray } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AddSenteceStructureComponent } from './add-sentece-structure/add-sentece-structure.component';
import { AddSenteceStructureExerciseComponent } from './add-sentece-structure-exercise/add-sentece-structure-exercise.component';
import { toJS } from 'mobx';

@Component({
  selector: 'app-sentece-structure',
  templateUrl: './sentece-structure.component.html',
  styleUrls: ['./sentece-structure.component.scss']
})
export class SenteceStructureComponent implements OnInit {

  tabs = TABS.SENTENCE_STRUCTURE;
  TITLE = "Modules"
  ITEM: any;
  ITEM_KEY: any;
  QUESTION_LIST: any[];
  MODULE_KEY: any;
  MODULE: any;

  form: FormGroup;
  name: AbstractControl;
  grammar: AbstractControl;
  instruction: AbstractControl;
  defaultInstruction: AbstractControl;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  SKILL = 'grammar';
  SKILL_NAME = 'Grammar';
  ACTIVITY_TYPE = 'sentece_structure'
  WORDS: any[] = [];
  ACTIVITY_TYPE_LIST: any[];
  ACTIVITY_TYPE_OBJECT: any = {};

  constructor(private router: Router
    , private route: ActivatedRoute
    , public resource: ResourceStore
    , private fb: FormBuilder
    , private dialog: MatDialog
    , public store: ActivityStore
    , private location: Location
    , private auth: AuthStore
    , private ds: DataService
    , private snackBar: MatSnackBar
  ) { }
  goBack() {
    this.router.navigate([`/modules/submitted/${this.MODULE.lessonKey}/lesson`])
  }

  // goBackToActivityType() {
  //   this.router.navigate([`/modules/submitted/${this.MODULE.lessonKey}/lesson`])
  // }
  // newActivity() {
  //   this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/draft`])
  // }

  async ngOnInit() {
    this.form = this.fb.group({
      name: [null, [Validators.required]],
      instruction: [null],
      defaultInstruction: [true],
      grammar: [null],
    })
    await this.auth.fetchUser();
    this.route.params.subscribe(async params => {
      const { id, MODULE_KEY } = params;
      this.ITEM_KEY = id === 'draft' ? null : id;
      this.MODULE_KEY = MODULE_KEY
      this.tabs = TABS.SENTENCE_STRUCTURE.filter(m => m.key === this.SKILL).map(m => ({ path: `${m.path}/${MODULE_KEY}/${m.key === SKILL_OBJECT.GRAMMAR.key ? id : 'draft'}`, label: m.label, key: m.key }))
      this.ACTIVITY_TYPE_LIST = await this.store.fetchActivityType()
      this.ACTIVITY_TYPE_OBJECT = this.ACTIVITY_TYPE_LIST.filter(m => m.key === this.ACTIVITY_TYPE)[0];
      this.MODULE = await this.store.fetchModule(this.MODULE_KEY)
      if (!this.MODULE) {
        this.router.navigate(['/404']);
        return;
      }
      if (id !== 'draft') {
        this.store.fetchActivity(id, doc => {
          this.ITEM = doc;
          if (!doc) {
            this.QUESTION_LIST = [];
            this.goBack()
            return;
          }
          const { name, questions, instruction, defaultInstruction, grammar } = doc;
          this.form.patchValue({ name, instruction, defaultInstruction, grammar })
          this.QUESTION_LIST = questions;
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
        this.form.patchValue({ name: null, instruction: null, defaultInstruction: true, grammar: null })
      }
    })
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    const { fetchActivityRef } = this.store;
    fetchActivityRef && fetchActivityRef.unsubscribe();
    const { fetchActivityByModuleRef } = this.resource;
    fetchActivityByModuleRef && fetchActivityByModuleRef.unsubscribe();
  }

  onSave(f: any, isBack: boolean) {
    if (this.form.valid) {
      this.processClose = isBack ? true : false;
      this.processNew = !isBack;
      this.form.disable();
      const { name, instruction, defaultInstruction, grammar } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const activity: IActivity = {
        key: this.ITEM ? this.ITEM.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: this.ITEM ? this.ITEM.created_at : new Date(),
        created_by: this.ITEM ? this.ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: null,
        organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
        organizationKey: selectedCompanyKey,
        created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        //fields
        name: name || null,
        grammar: grammar || null,
        instruction: instruction || null,
        defaultInstruction: defaultInstruction || false,
        questions: this.ITEM ? this.ITEM.questions : [],
        hasSubActivity: true,
        //module ref
        skillKey: this.ITEM ? this.ITEM.skillKey : this.SKILL,
        skillRef: this.ds.skillRef().doc(this.SKILL).ref,
        skillName: this.SKILL_NAME,
        activityTypeKey: this.ACTIVITY_TYPE,
        activityTypeRef: this.ds.activityTypeRef().doc(this.ACTIVITY_TYPE).ref,
        activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
        moduleKey: this.MODULE_KEY,
        moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(this.MODULE_KEY).ref,
      }
      this.store.addItem(activity, this.MODULE, this.ITEM ? true : false, (success, res) => {
        if (success) {
          this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
          this.processClose = false;
          this.processNew = false;
          if (isBack) {
            this.goBack();
          }
          else {
            this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/${activity.key}`])
          }
          this.form.enable();
        }
      })
    }
  }


  delete(word) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: word.name, title: 'Delete Word/Phrase' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.form.disable();
        const { name, instruction, defaultInstruction, grammar } = this.form.value;
        const { user, selectedCompanyKey } = this.auth;
        const { questions } = this.ITEM;
        const WORD_DATA = removeObjArray(questions, word.key)
        const registerStatus = STATUS_OBJECT.submitted;
        const activity: IActivity = {
          key: this.ITEM.key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : new Date(),
          created_by: this.ITEM ? this.ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          //fields
          name: name || null,
          grammar: grammar || null,
          instruction: instruction || null,
          defaultInstruction: defaultInstruction || false,
          questions: WORD_DATA,
          hasSubActivity: true,
          //module
          skillKey: this.ITEM.skillKey,
          skillRef: this.ITEM.skillRef,
          skillName: this.SKILL_NAME,
          activityTypeKey: this.ITEM.activityTypeKey,
          activityTypeRef: this.ITEM.activityTypeRef,
          activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
          moduleKey: this.ITEM.moduleKey,
          moduleRef: this.ITEM.moduleRef,
        }
        this.store.update(activity, (success, res) => {
          this.snackBar.open("Question has been deleted successful.", "Done", { duration: 1000 });
          this.form.enable();
        })
      }
    })
  }


  addNewLine(item: any, answer) {
    let dialogRef = this.dialog.open(AddSenteceStructureComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        ANSWER: answer || null,
        EXERCISE: item || null,
        MODULE: this.MODULE,
      },
      panelClass: 'item-list-panel',
      width: '35vw',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  addNewExercise(item: any) {
    this.store.options = item ? item.answers : [];
    let dialogRef = this.dialog.open(AddSenteceStructureExerciseComponent, {
      data: {
        EXERCISE: item || null,
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        MODULE: this.MODULE,
      },
      panelClass: 'item-list-panel',
      width: '35vw',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  deleteAnswer(question, answer) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: question.name, title: 'Delete Answer' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        const answerAfterRemove = removeObjArray(question.answers || [], answer.key);
        question.answers = answerAfterRemove;
        const { questions } = this.ITEM;
        const questionsData = pushObjArray(questions, question)
        this.ITEM.questions = questionsData;
        this.store.addItem(this.ITEM, this.MODULE, this.ITEM ? true : false, (success, res) => {
          this.snackBar.open("Answer has been removed successful.", "Done", { duration: 1000 });
        })
      }
    })
  }


}
